import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import Breed from "api/types/models/breed";
import QueryTags from "api/types/QueryTags";
import {
  GetBreedRequest,
  GetBreedsRequest,
  UpdateBreedRequest,
} from "api/types/requests";
import PaginatedResponse from "api/types/PaginatedResponse";

const breedEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getBreed: builder.query<Breed, GetBreedRequest>({
    query: ({ breedUuid }) => `/breeds/${breedUuid}`,
    providesTags: ["Breed"],
  }),

  getBreeds: builder.query<PaginatedResponse<Breed[]>, GetBreedsRequest>({
    query: ({ page, size, search }) => ({
      url: "/breeds",
      params: {
        ...(page && { page }),
        ...(size && { size }),
        ...(search && { search }),
      },
    }),
    providesTags: ["Breeds"],
  }),

  updateBreed: builder.mutation<Breed, UpdateBreedRequest>({
    query: ({ breedUuid, body }) => ({
      url: `/breeds/${breedUuid}`,
      method: "put",
      body,
    }),
    invalidatesTags: ["Breeds", "Breed"],
  }),
});

export default breedEndpoints;
